// src/components/BlogSidebar.tsx
import { NewsletterForm } from './NewsletterForm';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '../lib/categories';

export function BlogSidebar() {
  const location = useLocation();

  return (
    <div className="space-y-10 sticky top-24">
      <NewsletterForm source="blog_sidebar" variant="compact" />

      <div className="bg-gray-900 p-6 rounded-lg shadow border border-gray-800">
        <h3 className="text-lg font-semibold mb-4 text-yellow-300">Categories</h3>
        <ul className="space-y-2">
          {categories.map((category) => {
            const isActive = location.pathname.includes(`/category/${category.slug}`);
            return (
              <li key={category.slug}>
                <Link
                  to={`/blog/category/${category.slug}`}
                  className={`block px-3 py-2 rounded-md text-sm font-medium transition-all ${
                    isActive
                      ? 'bg-yellow-500 text-black'
                      : 'text-yellow-100 hover:bg-yellow-500/10 hover:text-yellow-300'
                  }`}
                >
                  {category.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
